"use client";

import { useState } from 'react';
import { Link } from 'react-router-dom';
import contractImg1 from '../../assets/images/resources/factoryforcontact.png';
import contractShape1 from '../../assets/images/shapes/contact-three-shape-1.png';
import locationMap from '../../assets/images/shapes/location-map.png';
import axios from 'axios';
import successPic from '../../assets/images/icon/success.png'
import { Modal, ModalHeader } from 'react-bootstrap';
// Define a list of services for the dropdown
const services = [
  "Choose an Option",
  "Movable Excavator",
  "Scrap Magnet",
  "Vertical Heavy Duty Scrap Shear",
  "Hydraulic Scrap Baler",
  "Horizotal Automatic Container Shear",
  "Fixed Boom Excavator",
  "Scrap Grabber"
];

export default function ContactComponent() {
  const [selectedService, setSelectedService] = useState(services[0]);
  const [showModal, setShowModal] = useState(false)
  const [data, setData] = useState({
    name: '',
    email: '',
    mobile: '',
    message: ''
  })

  console.log('datafromform', data)
  const handleCloseModal = () => {
    setShowModal(false)
  }


  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form Data:', data);
    const payload = {
      ...data,
      machineName: selectedService,
      website: 'Ramana Steels'
    }
    try {
      // const response = await axios.post('http://localhost:4000/userform', payload);
      const response = await axios.post('https://api.ramanamachines.com:4000/userform', payload);

      setData({
        name: '',
        email: '',
        message: '',
        mobile: ''
      })
      setSelectedService(services[0])
      if (response) { setShowModal(true) }


    }
    catch (error) { console.log("Error", error) }
  }

  return (
    <>
      {/* Contact Three Start */}
      <section className="contact-three">
        <div className="container" style={{ marginBottom: '120px' }}>
          <div className="row">

            <div className="col-xl-12 wow fadeInRight" data-wow-delay="300ms">
              <div className="contact-three__right">
                <div className="contact-three__shape-1">
                  <img src={contractShape1} alt="" />
                </div>
                <h3 className="contact-three__right-title">Contact Us</h3>
                <form
                  className="contact-form-validated contact-three__form"
                  action="/assets/inc/sendemail.php"
                  method="post"
                  noValidate
                >
                  <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-6">
                      <div className="contact-three__input-box">
                        <h4 className="contact-three__input-title">Name</h4>
                        <input type="text" name="name" placeholder="Your Name" value={data.name} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-6">
                      <div className="contact-three__input-box">
                        <h4 className="contact-three__input-title">Email</h4>
                        <input type="email" name="email" placeholder="Your Email" value={data.email} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-6">
                      <div className="contact-three__input-box">
                        <h4 className="contact-three__input-title">Number</h4>
                        <input type="text" name="mobile" placeholder="Your Number" value={data.mobile} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-6">
                      <div className="contact-three__input-box">
                        <h4 className="contact-three__input-title">Option</h4>
                        <div className="select-box">
                          <select
                            className="selectmenu wide"
                            value={selectedService}
                            onChange={(e) => setSelectedService(e.target.value)}
                          >
                            {services.map((service, index) => (
                              <option key={index} value={service}>
                                {service}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <h4 className="contact-three__input-title">Message</h4>
                      <div className="contact-three__input-box text-message-box">
                        <textarea name="message" value={data.message} onChange={handleChange} placeholder="Message here.."></textarea>
                      </div>
                      <div className="contact-three__btn-box-two">
                        <button type="submit" className="thm-btn-two contact-three__btn-two" onClick={handleSubmit}>
                          Contact Now<span className="icon-dubble-arrow-right"></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="result"></div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className='shadow p-3 mb-3 bg-gray' style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: '80px', alignItems: 'center', backgroundImage: `url(${locationMap})`, maxWidth: '1218px', height: '672px', margin: 'auto' }}>
          <h3>Global Presence, Trusted Worldwide</h3>
          <p>Ramana Machines has expanded its reach beyond India, successfully installing machines in numerous countries across the globe. Our machines are now operating in Nepal, Bangladesh, Sri Lanka, Bhutan, South Africa, Nigeria, UAE, and many more. With each installation, we continue to demonstrate our commitment to delivering high-quality machinery and expert service, no matter where you are. Join the growing list of satisfied global customers who trust Ramana Machines for their industry needs.

          </p>

        </div> */}
      </section>

      <Modal show={showModal} size="sm" onHide={handleCloseModal} centered>
        <Modal.Header closeButton className="border-0 justify-content-center">

        </Modal.Header>
        <Modal.Body className="text-center">
          <img src={successPic} style={{ width: "100px", height: "100px", marginBottom: '20px' }} alt='success' />
          <p>Form submitted successfully!</p>
          <p>Thank you for showing interest!</p>
        </Modal.Body>
      </Modal>

      {/* Contact Three End */}
    </>
  );
}
